// extracted by mini-css-extract-plugin
export default {"popup-info__content":"PopupInfo_popup-info__content__gIUSf"};